import { render, staticRenderFns } from "./PetitionSteppers.vue?vue&type=template&id=61d27902"
import script from "./PetitionSteppers.vue?vue&type=script&setup=true&lang=ts"
export * from "./PetitionSteppers.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports